<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-row>
                <v-overlay :value="overlayDesgarga" >
                    <div class="align-center justify-center text-center">
                        <v-progress-circular
                            indeterminate
                            :size="100"
                            :width="7"
                            color="#2DB9D1"
                        >
                            <v-img
                                src="/static/icon/favicon.ico"
                                :width="60"
                            ></v-img>
                        </v-progress-circular>
                        <p>{{frase}}</p>
                    </div>
                </v-overlay>
                <v-col cols="12" lg="12" v-if="showBody">
                    <data-table
                        ref="tableIncidencias"
                        :tableName="'Incidencias'"
                        :url="url"
                        :columns="columns"
                        @loadModalData="loadModalData"
                        :filters="filters"
                        @setFilters="setFilters"
                        :perPage="[10, 25, 50, 100]"
                    >
                        <template slot="actionButtonsLeft">
                            <div class="botonAgregar" style="padding-right: 10px;">
                                <v-btn
                                    rounded
                                    color="#004BAF"
                                    class="btnAdd"
                                    right
                                    @click="abrirModal('add')"
                                >
                                    <v-icon dark class="mr-2">add</v-icon>Agregar
                                    <div class="mr-4"></div>
                                </v-btn>
                            </div>
                        </template>
                        <template v-if="rol == 'admin-empresa' || rol == 'admin-sucursal'" slot="actionButtonsLeft">
                            <div style="padding-right: 10px;">
                                <v-speed-dial
                                    v-model="btnDoc"
                                    direction="bottom"
                                    open-on-hover
                                    transition="scale-transition"
                                    class="btn-download-cloud"
                                >
                                    <template v-slot:activator>
                                        <v-btn
                                            v-model="btnDoc"
                                            color="#FFFFFF"
                                            fab
                                            class="btn-download-cloud"
                                            elevation="3"
                                        >
                                            <v-icon color="#96999A" v-if="btnDoc">mdi-close</v-icon>
                                            <v-icon color="#96999A" class="icono-download-cloud" v-else></v-icon>
                                        </v-btn>
                                    </template>
                                    

                                    <v-btn
                                        fab
                                        small
                                        color="#FFFFFF"
                                        @click="exportar('pdf')"
                                    >
                                        <v-icon color="red">mdi-file-pdf</v-icon>
                                    </v-btn>
                                    <v-btn
                                        fab
                                        small
                                        color="#FFFFFF"
                                        @click="exportar('xlsx')"
                                    >
                                        <v-icon color="green">mdi-file-excel</v-icon>
                                    </v-btn>
                                </v-speed-dial>
                            </div>
                        </template>
                        <template v-if="rol == 'root' || rol == 'admin'" slot="actionButtonsLeft">
                            <v-btn
                                color="#FFFFFF"
                                fab
                                class="btn-download-cloud2 mr-3"
                                elevation="0"
                                width="42"
                                height="42"
                                @click="abrirModalReportes()"
                            >
                                <v-icon color="#96999A" class="icono-download-cloud"></v-icon>
                            </v-btn>
                        </template>


                        

                        <template slot="filters">
                            <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                <VuetifyDatePicker
                                    outlined
                                    v-model="advancedSearch.fecha_inicio"
                                    :valorDefecto="advancedSearch.fecha_inicio"
                                    label="Fecha inicial"
                                    placeholder="dd/mm/aaaa"
                                    ref="SearchFechaInicio"
                                />
                            </v-col>
                            <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                <VuetifyDatePicker
                                    outlined
                                    v-model="advancedSearch.fecha_final"
                                    :valorDefecto="advancedSearch.fecha_final"
                                    label="Fecha final"
                                    placeholder="dd/mm/aaaa"
                                    ref="SearchFechaFinal"
                                />
                            </v-col>
    
                            <template v-if="rol == 'root'">
                                <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="clientes"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Cliente"
                                        persistent-hint
                                        v-model="cliente_value"
                                    ></v-autocomplete>
                                </v-col>
                            </template>

                            <template v-if="rol == 'root' || rol == 'admin'">
                                <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="empresas"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Empresa"
                                        persistent-hint
                                        v-model="empresa_value"
                                    ></v-autocomplete>
                                </v-col>
                            </template>

                            <template v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'">
                                <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="sucursales"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Sucursal"
                                        persistent-hint
                                        v-model="sucursal_value"
                                    ></v-autocomplete>
                                </v-col>
                            </template>

                            <template
                                v-if="
                                    rol == 'root' ||
                                    rol == 'admin' ||
                                    rol == 'admin-empresa' ||
                                    rol == 'admin-sucursal'
                                "
                            >
                                <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="departamentos"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Departamento"
                                        persistent-hint
                                        v-model="advancedSearch.departamento_id"
                                    ></v-autocomplete>
                                </v-col>
                            </template>

                            <v-col cols="12" xs="12" sm="6" md="6" class="py-0" v-if="rol != 'empleado'">
                                <v-autocomplete
                                    outlined
                                    :items="empleados"
                                    item-text="nombreClave"
                                    item-value="id"
                                    label="Empleados"
                                    persistent-hint
                                    v-model="advancedSearch.empleado_id"
                                    data-vv-name="Empleados"
                                    :error-messages="errors.collect('Empleados')"
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                <v-autocomplete
                                    outlined
                                    :items="tiposIncidencias"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Tipo incidencia"
                                    persistent-hint
                                    v-model="advancedSearch.tipo_id"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                <v-autocomplete
                                    outlined
                                    :items="estatus_plus"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Estatus"
                                    persistent-hint
                                    v-model="advancedSearch.estatus_id"
                                ></v-autocomplete>
                            </v-col>
                        </template>

                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id" v-for="item in data" >
                                <td v-if="rol != 'empleado'">
                                    <div >
                                        <v-list  color="transparent" class="py-0 my-0">
                                            <v-list-item class="py-0 my-0 px-0">
                                                <v-list-item-avatar  class="py-0 my-0">
                                                    <v-img  :src="urlAvatar+item.foto"></v-img>
                                                </v-list-item-avatar>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-list-item-content v-on="on" class="ml-0 py-0 my-0">
                                                            <v-list-item-title class="tblPrincipal">{{ item.nombre_completo }}</v-list-item-title>
                                                        </v-list-item-content>
                                                    </template>
                                                    <span>{{ item.nombre_completo }}</span>
                                                 </v-tooltip>  
                                            </v-list-item>
                                        </v-list>
                                    </div>
                                </td>

                                <td
                                    v-if="rol != 'empleado'"
                                >
                                    <div>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-chip
                                                    class="vChip"
                                                    :color="item.color"
                                                    text-color="#000"
                                                    v-on="on"
                                                >
                                                    {{
                                                        item.nombre_tipo.length < 12
                                                        ? item.nombre_tipo
                                                        : item.nombre_tipo.substr(0, 11) + "..."
                                                    }}
                                                </v-chip>
                                            </template>
                                            <div>
                                                <span class="font-weight-bold">{{ item.nombre_tipo }}</span>
                                                <v-divider color="#fff" class="mb-1"></v-divider>
                                                <span>{{ item.descripcion }}</span>
                                            </div>
                                        </v-tooltip>
                                    </div>
                                </td>
                                <td
                                    v-else
                        
                                >
                                    <div>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-chip
                                                    class="vChip"
                                                    :color="item.color"
                                                    text-color="#000"
                                                    v-on="on"
                                                >
                                                    {{
                                                        item.nombre_tipo.length < 12
                                                        ? item.nombre_tipo
                                                        : item.nombre_tipo.substr(0, 11) + "..."
                                                    }}
                                                </v-chip>
                                            </template>
                                            <span>{{ item.nombre_tipo }}</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">
                                        {{ dateFormat(item.fecha_inicio) }}
                                    </div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">
                                        {{ dateFormat(item.fecha_final) }}
                                    </div>
                                </td>
                                <td class="tblPrincipal" v-if="rol == 'empleado'">
                                    <div>
                                        {{ item.descripcion }}
                                    </div>
                                </td>
                                <!--TODO: abrir menu para actualizar status-->
                                <td>
                                    <div class="tblCenter">
                                        <div 
                                        v-if="item.activo == false" 
                                        class="mx-0 px-0 div-cancelado tipoLetra d-flex align-center">
                                            <img
                                                style="height: 20px; width: 20px;  background-color: transparent;"
                                                src="/static/icon/block.png"
                                                alt="Empleado"
                                                class="d-inline"
                                                />
                                            <p class="d-inline ma-0">
                                                &nbsp;&nbsp;&nbsp; Cancelado
                                            </p>
                                        </div>
                                        
                                        <v-menu
                                            v-else-if="rol !== 'empleado'"
                                            buttom
                                            content-class="menuClassAcciones mt-6"
                                            >
                                            <template v-slot:activator="{on,attrs}">    
                                                <div
                    
                                                v-bind="attrs"
                                                v-on="on"
                                                class="mx-0 px-0 tipoLetra d-flex align-center"
                                                :class="getColorTextoStatus(item.valor_estatus)"
                                                >
                                                <img
                                                v-if="item.valor_estatus === 'estatus_aprobado'"
                                                style="height: 20px; width: 20px;  background-color: transparent;"
                                                src="/static/icon/aprovado.png"
                                                alt="Empleado"
                                                class="d-inline"
                                                />
                                                <img
                                                v-else-if="item.valor_estatus === 'estatus_rechazado'"
                                                style="height: 20px; width: 20px;  background-color: transparent;"
                                                src="/static/icon/cancelado.png"
                                                alt="Empleado"
                                                class="d-inline"
                                                />
                                                <img
                                                v-else-if="item.valor_estatus === 'estatus_pendiente'"
                                                style="height: 20px; width: 20px;  background-color: transparent;"
                                                src="/static/icon/pendiente.png"
                                                alt="Empleado"
                                                class="d-inline"
                                                />
                                                <img
                                                v-else
                                                style="height: 20px; width: 20px;  background-color: transparent;"
                                                src="/static/icon/revision.png"
                                                alt="Empleado"
                                                class="d-inline"
                                                />
                                                <p class="d-inline ma-0">
                                                    &nbsp;&nbsp;&nbsp; {{ item.nombre_estatus }}
                                                </p>
                                                </div>
                                                
                                            </template>
                                            <div class="btnAccionesContenedor" style="width: auto;">
                                                <v-container
                                                v-for="s in estatus_plus"
                                                :key="s.id"  
                                                class="btnAccionesItem py-2"
                                                :class="(s.id == item.estatus_id) ? 'd-none' : ''"
                                                @click="(s.nombre !== 'Cancelado') ? actualizarEstatus(item,s.id) : abrirCancelar(item.id)"
                                                >
                                                    <span>{{ s.nombre }}</span>
                                                </v-container>
                                            </div>
                                        </v-menu>
                                        <div
                                        v-else
                                        class="mx-0 px-0 tipoLetra d-flex align-center"
                                        :class="getColorTextoStatus(item.valor_estatus)"
                                        >
                                        <img
                                        v-if="item.valor_estatus === 'estatus_aprobado'"
                                        style="height: 20px; width: 20px;  background-color: transparent;"
                                        src="/static/icon/aprovado.png"
                                        alt="Empleado"
                                        class="d-inline"
                                        />
                                        <img
                                        v-else-if="item.valor_estatus === 'estatus_rechazado'"
                                        style="height: 20px; width: 20px;  background-color: transparent;"
                                        src="/static/icon/cancelado.png"
                                        alt="Empleado"
                                        class="d-inline"
                                        />
                                        <img
                                        v-else-if="item.valor_estatus === 'estatus_pendiente'"
                                        style="height: 20px; width: 20px;  background-color: transparent;"
                                        src="/static/icon/pendiente.png"
                                        alt="Empleado"
                                        class="d-inline"
                                        />
                                        <img
                                        v-else
                                        style="height: 20px; width: 20px;  background-color: transparent;"
                                        src="/static/icon/revision.png"
                                        alt="Empleado"
                                        class="d-inline"
                                        />
                                        <p class="d-inline ma-0">
                                            &nbsp;&nbsp;&nbsp; {{ item.nombre_estatus }}
                                        </p>
                                        </div>
                                    </div>
                                </td>

                                <template v-if="rol != 'empleado'">
                                    <td>
                                        <div class="tblOpciones">
                                        <v-menu 
                                        buttom
                                        left
                                        content-class="menuClassAcciones mt-0"                                         
                                        >
                                        <template v-slot:activator="{on,attrs}">
                                                <v-btn class="botonHover"
                                                    v-bind="attrs"
                                                    dark
                                                    fab
                                                    small
                                                    icon
                                                    v-on="on"
                                                    >
                                                    <v-icon class="tamIconoBoton iconoDelgadoBoton">mdi-dots-vertical</v-icon>
                                                </v-btn>
                                            </template>
                                            <div class="btnAccionesContenedor" style="width: auto;">
                                                <template v-if="item.activo == true">
                                                    <div 
                                                    @click="abrirModal('update',item)" 
                                                    class="btnAccionesItem py-2"
                                                    v-if="(item.valor_estatus == 'estatus_aprobado' && item.valor_tipo == 'tipo_incidencia_incapacidad' && sistema == 'nominas') ? false:true"
                                                    >
                                                        <span>Editar</span>
                                                    </div>
                                                    <div 
                                                    @click="abrirModal('subir-archivo',item)" 
                                                    class="btnAccionesItem py-2"
                                                    v-if="item.valor_tipo !== 'tipo_incidencia_incapacidad' && item.valor_estatus === 'estatus_aprobado' "
                                                    >
                                                        <span>Subir archivo</span>
                                                    </div>
                                                    <div 
                                                    @click="abrirCancelar(item.id)" 
                                                    class="btnAccionesItem py-2"
                                                    v-if="(item.valor_estatus == 'estatus_aprobado' && item.valor_tipo == 'tipo_incidencia_incapacidad' && sistema == 'nominas') ? false:true"
                                                    >
                                                        <span>Cancelar</span><br />
                                                    </div>
                                                    <div 
                                                    @click="descargar(item)" 
                                                    class="btnAccionesItem py-2"
                                                    v-if="item.url_archivo && item.valor_estatus !== 'estatus_rechazado'"
                                                    >
                                                    <span>Descargar archivo</span><br />
                                                    </div>
                                                    <div 
                                                    @click="descargarFormato(item)" 
                                                    class="btnAccionesItem py-2"
                                                    v-if="item.valor_tipo == 'tipo_incidencia_vacaciones' && item.valor_estatus === 'estatus_aprobado'"
                                                    >
                                                    <span>Descargar formato</span><br />
                                                    </div>
                                                </template>
                                                <!--Informacion de cancelacion-->
                                                <v-menu
                                                    v-else-if="item.activo == false"
                                                    left
                                                    buttom
                                                    :close-on-content-click="false"
                                                    class="elevation-0 d-inline" 
                                                    content-class="mt-0 menuClassAccionesVer menu-width"
                                                    v-model="item.menu"
                                                >
                                                    <template v-slot:activator="{on,attrs}">
                                                        <div 
                                                        v-on="on"
                                                        v-bind="attrs"
                                                        class="btnAccionesItem py-2"
                                                        >
                                                            <span>Ver motivo de cancelación</span>
                                                        </div>
                                                    </template>
                                                    <v-list>
                                                        <div xs="1" sm="1" md="1" lg="1" class="v-btn-alineacion background-transparent" style="float: right;">
                                                            <v-btn
                                                            @click="item.menu = false"
                                                            small
                                                            icon
                                                            text
                                                            :ripple="false" 
                                                            class="v-btn-cerrar mr-2"
                                                            >
                                                            <v-icon class="icono-cerrar"></v-icon>
                                                        </v-btn>
                                                    </div>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-subtitle>
                                                                <v-row class="pa-0 ma-0">
                                                                    <v-col cols="12" xs="12" sm="12" md="12"  class="py-0">
                                                                        <p class="informacionGeneralTitulo">Información de cancelación</p>
                                                                    </v-col> 
                                                                    <template v-if="item.eliminacion">
                                                                        <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                                                            <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                                                                <p class="mb-0 informacionGeneralSubtitle">Responsable:</p>
                                                                                <p class="informacionGeneralText text-wrap">{{item.eliminacion.responsable}}</p>
                                                                            </v-col>
                                                                            <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                                                                <p class="mb-0 informacionGeneralSubtitle">Fecha de cancelación:</p>
                                                                                <p class="informacionGeneralText text-wrap">{{dateFormat(item.eliminacion.fecha, 'modal')}}</p>
                                                                            </v-col>
                                                                            <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                                                                <p class="mb-0 informacionGeneralSubtitle">Motivo:</p>
                                                                                <p class="informacionGeneralText text-wrap">{{item.eliminacion.motivo}}</p>
                                                                            </v-col>
                                                                        </v-col>
                                                                    </template>
                                                                    <v-col cols="12" xs="12" sm="12" md="12" class="py-0" v-else>
                                                                        <p class="informacionGeneralText text-wrap">No hay información para mostrar</p>
                                                                    </v-col>
                                                                    </v-row>
                                                                </v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-list>
                                                
                                                </v-menu>
                                            </div>
                                        </v-menu>
                                        </div> 
                                    </td>
                                </template>
                                <template v-if="rol == 'empleado'">
                                    <td>
                                        <div class="tblOpciones">
                                            <v-menu 
                                            buttom
                                            left
                                            content-class="menuClassAcciones mt-0"                                         
                                            >
                                                <template v-slot:activator="{on,attrs}">
                                                    <v-btn class="botonHover"
                                                        v-bind="attrs"
                                                        dark
                                                        fab
                                                        small
                                                        icon
                                                        v-on="on"
                                                        >
                                                        <v-icon class="tamIconoBoton iconoDelgadoBoton">mdi-dots-vertical</v-icon>
                                                    </v-btn>
                                                </template>
                                                <div class="btnAccionesContenedor" style="width: auto;">
                                                    <template v-if="item.activo == true">

                                                        <div 
                                                            class="btnAccionesItem py-2"
                                                            v-if="(!item.url_archivo && item.valor_estatus !== 'estatus_aprobado') || item.valor_estatus == 'estatus_rechazado'"
                                                        >
                                                            <span>{{item.valor_estatus == 'estatus_rechazado' ? 'No hay opciones disponibles' :  'No hay archivo para descargar'}}</span><br />
                                                        </div>
                                                       
                                                        <div 
                                                        @click="descargar(item)" 
                                                        class="btnAccionesItem py-2"
                                                        v-if="item.url_archivo && item.valor_estatus !== 'estatus_rechazado'"
                                                        >
                                                        <span>Descargar archivo</span><br />
                                                        </div>
                                                        <div 
                                                        @click="abrirModal('subir-archivo',item)" 
                                                        class="btnAccionesItem py-2"
                                                        v-if="item.valor_tipo !== 'tipo_incidencia_incapacidad' && item.valor_estatus === 'estatus_aprobado'"
                                                        >
                                                        <span>Subir archivo</span><br />
                                                        </div>
                                                        <div 
                                                        @click="descargarFormato(item)" 
                                                        class="btnAccionesItem py-2"
                                                        v-if="item.valor_tipo == 'tipo_incidencia_vacaciones' && item.valor_estatus === 'estatus_aprobado'">
                                                        <span>Descargar formato</span><br />
                                                        </div>
                                                    </template>
                                                     <v-menu
                                                    v-else-if="item.activo == false"
                                                    left
                                                    buttom
                                                    :close-on-content-click="false"
                                                    class="elevation-0 d-inline" 
                                                    content-class="mt-0 menuClassAccionesVer menu-width"
                                                    v-model="item.menu"
                                                >
                                                    <template v-slot:activator="{on,attrs}">
                                                        <div 
                                                        v-on="on"
                                                        v-bind="attrs"
                                                        class="btnAccionesItem py-2"
                                                        >
                                                            <span>Ver motivo de cancelación</span>
                                                        </div>
                                                    </template>
                                                    <v-list>
                                                        <div xs="1" sm="1" md="1" lg="1" class="v-btn-alineacion background-transparent" style="float: right;">
                                                            <v-btn
                                                            @click="item.menu = false"
                                                            small
                                                            icon
                                                            text
                                                            :ripple="false" 
                                                            class="v-btn-cerrar mr-2"
                                                            >
                                                            <v-icon class="icono-cerrar"></v-icon>
                                                        </v-btn>
                                                    </div>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-subtitle>
                                                                <v-row class="pa-0 ma-0">
                                                                    <v-col cols="12" xs="12" sm="12" md="12"  class="py-0">
                                                                        <p class="informacionGeneralTitulo">Información de cancelación</p>
                                                                    </v-col> 
                                                                    <template v-if="item.eliminacion">
                                                                        <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                                                            <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                                                                <p class="mb-0 informacionGeneralSubtitle">Responsable:</p>
                                                                                <p class="informacionGeneralText text-wrap">{{item.eliminacion.responsable}}</p>
                                                                            </v-col>
                                                                            <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                                                                <p class="mb-0 informacionGeneralSubtitle">Fecha de cancelación:</p>
                                                                                <p class="informacionGeneralText text-wrap">{{dateFormat(item.eliminacion.fecha, 'modal')}}</p>
                                                                            </v-col>
                                                                            <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                                                                <p class="mb-0 informacionGeneralSubtitle">Motivo:</p>
                                                                                <p class="informacionGeneralText text-wrap">{{item.eliminacion.motivo}}</p>
                                                                            </v-col>
                                                                        </v-col>
                                                                    </template>
                                                                    <v-col cols="12" xs="12" sm="12" md="12" class="py-0" v-else>
                                                                        <p class="informacionGeneralText text-wrap">No hay información para mostrar</p>
                                                                    </v-col>
                                                                    </v-row>
                                                                </v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                                </div>
                                            </v-menu>
                                           <!--  <v-tooltip bottom v-if="item.url_archivo">
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                        v-on="on"
                                                        color="#FFFFFF"
                                                        fab
                                                        class="btn-download-cloud2 mr-3"
                                                        elevation="0"
                                                        width="42"
                                                        height="42"
                                                        @click="item.url_archivo ? descargar(item): ''"
                                                    >
                                                        <v-icon color="#96999A" v-text="'$get_app_outline'"></v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Descargar archivo</span>
                                            </v-tooltip> -->

                                           <!--  <v-tooltip bottom v-if="!item.url_archivo">
                                                <template v-slot:activator="{ on }">
                                                    <v-btn v-on="on" class="botonHover" icon fab dark small>
                                                        <v-icon color="#cacaca" v-text="'$get_app_outline'"></v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>No hay archivo para descargar</span>
                                            </v-tooltip> -->
                                        </div>
                                    </td>
                                </template>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>
        </v-container>

        <template>
            <v-layout row justify-center>
                <v-dialog v-model="dialog" persistent max-width="600px" scrollable>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                    </template>

                    <perfect-scrollbar style="background:#FFF">
                        <v-card elevation="0">
                            <ValidationObserver ref="form" v-slot="{ invalid }">
                                <v-card-title class="justify-center card_titulo">
                                    <div class="headerModal">
                                        <img :src="imagen" class="imgModal" />
                                        <h2 class="titleModal">{{ titulo_modal }}</h2>
                                    </div>
                                </v-card-title>

                                <v-card-text class="card_texto">
                                    <div id="loadingModal" v-show="!finaliza_carga">
                                        <div id="loading">
                                            <v-progress-circular
                                                indeterminate
                                                :size="100"
                                                :width="7"
                                                color="blue"
                                            ></v-progress-circular>
                                        </div>
                                    </div>
                                    <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                                        <v-divider class="divider"></v-divider>
                                        <v-container >
                                            <v-row>
                                                <template v-if="accion !== 'subir-archivo'">
                                                    <template v-if="rol == 'root'">
                                                    <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                        <ValidationProvider v-slot="{ errors }" name="Cliente" rules="required">
                                                            <v-autocomplete
                                                                outlined
                                                                :items="clientes"
                                                                item-text="nombre"
                                                                item-value="id"
                                                                label="Cliente"
                                                                persistent-hint
                                                                v-model="cliente_value"
                                                                required 
                                                                :error-messages="errors"
                                                                />
                                                            </ValidationProvider>
                                                        </v-col>
                                                    </template>
                                                    <template v-if="rol == 'root' || rol == 'admin'">
                                                        <v-col cols="12" xs="12" :sm="(rol == 'root') ? '6':'12'" :md="(rol == 'root') ? '6':'12'" :lg="(rol == 'root') ? '6':'12'" :xl="(rol == 'root') ? '6':'12'" class="py-0">
                                                            <ValidationProvider v-slot="{ errors }" name="Empresa" rules="required">
                                                                <v-autocomplete
                                                                outlined
                                                                :items="empresas"
                                                                item-text="nombre"
                                                                item-value="id"
                                                                label="Empresa"
                                                                persistent-hint
                                                                v-model="empresa_value"
                                                                required 
                                                                :error-messages="errors"
                                                                />
                                                            </ValidationProvider>
                                                        </v-col>
                                                </template>
                                                <template v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'">
                                                    <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                        <ValidationProvider v-slot="{ errors }" name="Sucursal" rules="required">
                                                            <v-autocomplete
                                                            outlined
                                                            :items="sucursales"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            label="Sucursal"
                                                            persistent-hint
                                                            v-model="sucursal_value"
                                                            required 
                                                            :error-messages="errors"
                                                            />
                                                        </ValidationProvider>
                                                    </v-col>
                                                </template>
                                                <template v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa' || rol == 'admin-sucursal'">
                                                    <v-col 
                                                    cols="12"
                                                    xs="12" 
                                                    :sm="(rol == 'root' || rol == 'admin' || rol == 'admin-empresa') ? '6':'12'" 
                                                        :md="(rol == 'root' || rol == 'admin' || rol == 'admin-empresa') ? '6':'12'" 
                                                        :lg="(rol == 'root' || rol == 'admin' || rol == 'admin-empresa') ? '6':'12'" 
                                                        :xl="(rol == 'root' || rol == 'admin' || rol == 'admin-empresa') ? '6':'12'" 
                                                        class="py-0"
                                                        >
                                                        <ValidationProvider v-slot="{ errors }" name="Departamento" rules="required">
                                                            <v-autocomplete
                                                            outlined
                                                            :items="departamentos"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            label="Departamento"
                                                            persistent-hint
                                                            v-model="departamento_value"
                                                            required 
                                                            :error-messages="errors"
                                                            />
                                                        </ValidationProvider>
                                                    </v-col>
                                                </template>
                                                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Tipo incidencia" rules="required">
                                                        <v-autocomplete
                                                        outlined
                                                        :items="tiposIncidencias"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        label="Tipo incidencia"
                                                        persistent-hint
                                                        v-model="incidencia.tipo_id"
                                                        :error-messages="errors" 
                                                            required
                                                        />
                                                    </ValidationProvider>
                                                </v-col>
                                                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Descripción" rules="required">
                                                        <v-textarea
                                                        autofocus
                                                        v-model="incidencia.descripcion"
                                                            label="Descripción"
                                                            outlined
                                                            rows="2"
                                                            :error-messages="errors" 
                                                            required
                                                            ></v-textarea>
                                                    </ValidationProvider>
                                                </v-col>
                                                
                                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                    <VuetifyDatePicker
                                                    outlined
                                                    rules="required"
                                                    v-model="incidencia.fecha_inicio"
                                                    :valorDefecto="incidencia.fecha_inicio"
                                                    label="Fecha inicial"
                                                    placeholder="dd/mm/aaaa"
                                                    ref="FechaInicio"
                                                    />
                                                </v-col>
                                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                    <VuetifyDatePicker
                                                    outlined
                                                    rules="required"
                                                    v-model="incidencia.fecha_final"
                                                    :valorDefecto="incidencia.fecha_final"
                                                    label="Fecha final"
                                                    placeholder="dd/mm/aaaa"
                                                    ref="FechaFinal"
                                                    />
                                                </v-col>
                                                
                                                
                                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" v-if="rol != 'empleado'" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Estatus" rules="required">
                                                        <v-autocomplete
                                                        outlined
                                                        :items="estatus"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        label="Estatus"
                                                            persistent-hint
                                                            v-model="incidencia.estatus_id"
                                                            required 
                                                            :error-messages="errors"
                                                            />
                                                        </ValidationProvider>
                                                </v-col>
                                            </template>
                                            <v-col cols="12" xs="12" :sm="accion != 'subir-archivo' ? 6 : 12" :md="accion != 'subir-archivo' ? 6 : 12" :lg="accion != 'subir-archivo' ? 6 : 12" :xl="accion != 'subir-archivo' ? 6 : 12" class="py-0">
                                                <v-text-field
                                                outlined
                                                readonly
                                                class="pt-0 mt-0"
                                                label="Subir archivo"
                                                @click="pickFile"
                                                v-model="nombre_archivo"
                                                >
                                                    <template slot="append">
                                                        <v-icon class="tamIcono">attach_file</v-icon>
                                                    </template>
                                                </v-text-field>
                                                <input
                                                    type="file"
                                                    style="display: none"
                                                    ref="image"
                                                    id="archivo"
                                                    @change="onFilePicked"
                                                    />
                                                </v-col>
                                                <template v-if="(rol == 'root' || rol == 'admin' || rol == 'admin-empresa' || rol == 'admin-sucursal' || rol == 'admin-depto') && accion !== 'subir-archivo'">
                                                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Empleado" rules="required">
                                                        <v-autocomplete
                                                        outlined
                                                        :items="empleados"
                                                        item-text="nombreClave"
                                                        item-value="id"
                                                        label="Empleado"
                                                        persistent-hint
                                                        v-model="incidencia.empleado_id"
                                                        required 
                                                        :error-messages="errors"
                                                        />
                                                    </ValidationProvider>
                                                </v-col>
                                            </template>   
                                        </v-row>
                                    </v-container>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions v-show="finaliza_carga" class="d-flex justify-end card_accion">
                                    <button
                                        class="btnCerrar"
                                        @click="cerrarModal()"
                                        :disabled="loading_guardar"
                                    >
                                        Cancelar
                                    </button>
                                    <v-btn
                                        class="btnGuardar"
                                        @click="guardar()"
                                        :loading="loading_guardar"
                                    >
                                        Guardar
                                    </v-btn>
                                                
                                </v-card-actions>
                            </ValidationObserver>
                        </v-card>
                    </perfect-scrollbar>
                </v-dialog>
            </v-layout>
        </template>

        <template>
            <v-dialog v-model="dialogReportes" persistent max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" style="display: none;" class="botonModal" id="btnModalReportes"></v-btn>
                </template>
                <v-card>
                    <ValidationObserver ref="formReporte" v-slot="{ invalid }">
                        <v-card-title class="card_titulo padding_izquierdo padding_derecho">
                            <div class="headerModalStart">
                                <h2 class="titleModal_700_18">{{ tituloReportes }}</h2>
                            </div>
                        </v-card-title>
                        <v-card-text class="card_texto">
                            <div id="padre" v-show="isLoadingReportes">
                                <div id="loading">
                                    <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                                </div>
                            </div>
                            
                            <v-container v-show="!isLoadingReportes" grid-list-md id="contenedor">
                                <v-divider class="divider"></v-divider>
                                <v-row>
                                    <v-col v-if="rol == 'root'" cols="12" xs="12" sm="12" md="12" lg="12" class="py-0">
                                        <ValidationProvider v-slot="{ errors }" name="Cliente" rules="required">
                                            <v-autocomplete
                                                outlined
                                                label="Cliente"
                                                :items="clientes"
                                                item-text="nombre"
                                                item-value="id"
                                                persistent-hint
                                                v-model="cliente_value"
                                                required
                                                :error-messages="errors" 
                                            >
                                            </v-autocomplete>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col v-if="rol == 'root' || rol == 'admin'" cols="12" xs="12" sm="12" md="12" lg="12" class="py-0">
                                        <ValidationProvider v-slot="{ errors }" name="Empresa" rules="required">
                                            <v-autocomplete
                                                outlined
                                                label="Empresa"
                                                :items="empresas"
                                                item-text="nombre"
                                                item-value="id"
                                                persistent-hint
                                                v-model="empresa_value"
                                                required 
                                                :error-messages="errors" 
                                            >
                                            </v-autocomplete>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                        <VuetifyDatePicker
                                            rules="required"
                                            outlined
                                            v-model="advancedSearch.fecha_inicio"
                                            :valorDefecto="advancedSearch.fecha_inicio"
                                            label="Fecha inicial"
                                            placeholder="dd/mm/aaaa"
                                            ref="SearchFechaInicio"
                                        />
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                        <VuetifyDatePicker
                                            rules="required"
                                            outlined
                                            v-model="advancedSearch.fecha_final"
                                            :valorDefecto="advancedSearch.fecha_final"
                                            label="Fecha final"
                                            placeholder="dd/mm/aaaa"
                                            ref="SearchFechaFinal"
                                        />
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" class="py-0">
                                        <v-container class="ma-0 pa-0" fluid>
                                            <h4 class="tituloRadio">Tipo de reporte</h4>
                                            <v-radio-group class="ma-0 pa-0" v-model="tipoReporte">
                                                <v-radio
                                                    value="pdf"
                                                >
                                                    <template v-slot:label>
                                                        <div>Archivo pdf <v-icon color="red">mdi-file-pdf</v-icon></div>
                                                    </template> 
                                                </v-radio>
                                                <v-radio
                                                    value="xlsx"
                                                >
                                                    <template v-slot:label>
                                                        <div>Archivo excel <v-icon color="green">mdi-file-excel</v-icon></div>
                                                    </template> 
                                                </v-radio>
                                            </v-radio-group>
                                        </v-container>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end card_accion">
                            <button class="btnCerrar" @click="cerrarModal()" :disabled="isSaving">Cerrar</button>
                            <v-btn class="btnGuardar" @click="exportarReporte(tipoReporte)" :disabled="invalid" :loading="isSaving">Descargar</v-btn>
                        </v-card-actions>
                    </ValidationObserver>
                </v-card>
            </v-dialog>
        </template>
        
        <!--Modal cancelar-->
        <template>
            <v-dialog v-model="modal_cancelar" persistent max-width="500px">
                <v-card elevation="0" >
                    <ValidationObserver ref="formCancelar"  v-slot="{invalid}" >
                        <v-card-title class="card_titulo padding_izquierdo padding_derecho d-flex justify-center">
                            <div class="header-cancelar">
                                <img src="/static/icon/alert_warning.png" alt="Imagen candelar" class="mb-5">
                                <h2 class="header-cancelar-h2 mb-4 text-uppercase">Cancelar incidencia</h2>
                                <p class="header-cancelar-h3 mb-5">
                                    Para cancelar una incidencia, se requiere describir el motivo de la cancelación.
                                </p>
                            </div>
                    </v-card-title>
                    <v-card-text class="card_texto">
                        <v-container grid-list-md id="contenedor">
                            <v-row>
                                <v-col cols="12" xs="12" md="12" lg="12" xl="12" class="pb-0 pt-5">
                                    <ValidationProvider v-slot="{errors}" name="Motivo" rules="required">
                                        <v-textarea
                                        outlined
                                        label="Motivo de cancelación"
                                        no-resize
                                        rows="2"
                                        required
                                        :error-messages="errors"
                                        v-model="cancelacion.motivo"
                                        >
                                        </v-textarea>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" xs="12" sm="12" md="12" class="mt-0 pt-0">
                                    <div class="alert-div mt-0">
                                        <div>&nbsp;</div>
                                        <div class="d-flex">
                                            <div class="alert-sub pr-2">Cuando se cancela una incidencia, no será posible cambiar el estatus de la misma, por lo que es necesario crear una nueva.</div>
                                        </div>
                                        <div>&nbsp;</div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end card_accion">
                        <v-btn class="btnCerrar" :disabled="loading_guardar"  @click="cerrarModal()">Cerrar</v-btn>
                        <v-btn class="btnCancelar ml-4" :loading="loading_guardar" :disabled="invalid" @click="eliminar()">
                            <span class="mx-3">Cancelar incidencia</span>
                        </v-btn>
                    </v-card-actions>
                </ValidationObserver>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Datatable from "@/components/datatable/Datatable.vue";
import Notify from "@/plugins/notify";
import incidenciaApi from "../api/incidencias";
import tiposIncidenciasApi from "../api/tiposIncidencias";
import estatusIncidenciaApi from "../api/estatusIncidencias";
import empleadosApi from "../api/empleados";
import clientesApi from "../api/clientes";
import empresaApi from "../api/empresas";
import sucursalApi from "../api/sucursales";
import departamentoApi from "../api/departamentos";
import urlImg from "../plugins/Urlimagen";
import PerfectScrollbar from "perfect-scrollbar";
import VuetifyDatePicker from '@/components/VuetifyDatePicker.vue';
import { AccordionItem } from "@syncfusion/ej2-vue-navigations";

export default {
    components: {
        "data-table": Datatable,
        VuetifyDatePicker,
    },
    data() {
        return {
            url: "incidencias/find",
            columns: [
                {
                    label: "Empleado",
                    name: "empleado",
                    align: "left",
                    filterable: true,
                },
                {
                    label: "Incidencia",
                    name: "tipo",
                    align: "left",
                    filterable: true,
                },
                {
                    label: "Fecha inicio",
                    name: "fecha_inicio",
                    align: "left",
                    filterable: true,
                },
                {
                    label: "Fecha final",
                    name: "fecha_final",
                    align: "left",
                    filterable: true,
                },
                {
                    label: "Estatus",
                    name: "estatus",
                    align: "center",
                    filterable: true,
                },
                {
                    label: "Opciones",
                    name: "opciones",
                    align: "center",
                    filterable: false,
                },
            ],
            filters: {
                rol_name        : null,
                usuario_id      : null,
                paginate        : true,
                include_padres  : true,
                activo          : null,
                cliente_id      : null,
                empresa_id      : null,
                sucursal_id     : null,
                departamento_id : null,
                empleado_id     : null,
                order_by        : 'fecha_final',
            },
            advancedSearch: {
                rol_name    : null,
                usuario_id  : null,
                tipo_id     : null,
                estatus_id  : null,
                fecha_inicio: null,
                fecha_final : null,
                empleado_id : null,
                cliente_id  : null,
                empresa_id  : null,
                sucursal_id : null,
                departamento_id: null,
            },
            cancelacion:{
                id      : null,
                motivo  : ''
            },
            months: [
                "Ene",
                "Feb",
                "Mar",
                "Abr",
                "May",
                "Jun",
                "Jul",
                "Ago",
                "Sep",
                "Oct",
                "Nov",
                "Dic",
            ],
            loading_guardar : false,
            loading         : true,
            modal_cancelar  : false,
            dialog          : false,
            menu_inicio     : false,
            menu_final      : false,
            fecha_final     : null,
            fecha_inicio    : null,
            datosLogin      : null,
            calendar_inicio : false,
            calendar_fin    : false,
            incidencia      : {
                id          : null,
                descripcion : "",
                tipo_id     : null,
                fecha_inicio: "",
                fecha_final : "",
                empleado_id : "",
                cliente_id  : null,
                empresa_id  : null,
                sucursal_id : null,
                departamento_id: null,
                estatus_id  : "",
                url_archivo : "",
            },
            tiposIncidencias: [],
            valorIncidencia : null,
            rol             : "",
            accion          : "",
            titulo_modal    : "",
            finaliza_carga  : false,
            cliente_value   : null,
            empresa_value   : null,
            sucursal_value  : null,
            departamento_value: null,
            clientes        : [],
            empresas        : [],
            sucursales      : [],
            departamentos   : [],
            empleados       : [],
            estatus         : [],
            estatus_plus    : [],
            conteo_parametros: 0,
            incidencias     : [],
            nombre_archivo  : "",
            archivo         : 0,
            empleado_correo : null,
            url_archivo     : null,
            parametros      : null,
            urlAvatar       : null,
            btnDoc          :false,
            imagen          : "",
            sistema         : null,
            frase:'Descargando archivo',
            overlayDesgarga: false,
            isLoadingReportes: false,
            dialogReportes  : false,
            isSaving        : false,
            tituloReportes  : "Descargar reporte",
            tipoReporte     : "pdf",
            showBody        : false,
            
        };
    },
    watch: {
        cliente_value: function(val) {
            if(val != null){
                this.cambiaCliente(val);

                if(this.accion == 'search' && this.rol == 'root'){
                    this.getEmpleadosBusqueda()
                }
            }
        },
        empresa_value: function(val) {
            if(val != null){
                this.cambiaEmpresa(val);
                this.getTiposIncidencias(val);
                if(this.accion == 'search' && (this.rol == 'root' || this.rol == 'admin')){
                    this.getEmpleadosBusqueda()
                }
            }
        },
        sucursal_value: function(val) {
            if(val != null){
                this.cambiaSucursal(val);
                if(this.accion == 'search' && (this.rol == 'root' || this.rol == 'admin' || this.rol == 'admin-empresa')){
                    this.getEmpleadosBusqueda()
                }
            }
        },
        departamento_value: function(val) {
            if(val != null){
                this.cambiaDepartamento(val);
            }
        },
        'advancedSearch.departamento_id':function(val) {
            if(val != null){
                this.getEmpleadosBusqueda()
            }
        },
        'incidencia.tipo_id': async function(val){
            if (val != null) {
               /*  if (this.accion != 'search') {
                    console.log('id: ', this.incidencia.empresa_id)
                    await this.getTiposIncidencias(this.incidencia.empresa_id)
              }   */
                this.getEstatusIncidencia(val);
            }
        },
        

    },
    
    methods: {
        async listar(parametros = null) {
            let self = this;
            await this.resetValue();
            this.datosLogin = this.$session.get("usuario");
            this.rol = this.datosLogin.rol.name;
            this.urlAvatar = urlImg.getURL();
            this.filters.rol_name = this.datosLogin.rol.name;
            this.filters.usuario_id = this.datosLogin.id;

            if (this.rol == "admin") {
                this.incidencia.cliente_id = this.filters.cliente_id = this.datosLogin.cliente_id;
            } else if (this.rol == "admin-empresa") {
                this.incidencia.empresa_id = this.filters.empresa_id = this.datosLogin.empresa_id;
            } else if (this.rol == "admin-sucursal") {
                this.incidencia.sucursal_id = this.filters.sucursal_id = this.datosLogin.sucursal_id;
            } else if (this.rol == "admin-depto") {
                this.incidencia.departamento_id = this.filters.departamento_id = this.datosLogin.departamento_id;
            } else if (this.rol == "empleado") {
                this.columns = [
                    { label: "Incidencia", name: "incidencia", align: "left" },
                    { label: "Fecha inicio", name: "fecha_inicio_ok", align: "left" },
                    { label: "Fecha final", name: "fecha_final_ok", align: "left" },
                    { label: "Descripcion", name: "descripcion", align: "left" },
                    { label: "Estatus", name: "estatus", align: "center" },
                    {
                        label: "Opciones",
                        name: "opciones",
                        align: "center",
                        filterable: false,
                    },
                ];
                this.filters.empleado_id = this.$session.get("empleado").id;
            }
            this.showBody =true;
        },
        setFilters() {
            let tipo_id         = this.advancedSearch.tipo_id;
            let estatus_id      = null;
            let fecha_inicio    = this.advancedSearch.fecha_inicio;
            let fecha_final     = this.advancedSearch.fecha_final;
            let empleado_id     = null;
            let cliente         = this.cliente_value;
            let empresa         = this.empresa_value;
            let sucursal        = this.sucursal_value;
            let departamento    = this.advancedSearch.departamento_id;
            let activo          = null;
            let cliente_id;
            let empresa_id;
            let sucursal_id;
            let departamento_id;

            //busqueda por estatus
            if(this.advancedSearch.estatus_id == null){
                estatus_id = null;
                activo = null;
            
            }
            else if(this.advancedSearch.estatus_id == 999){
                estatus_id = null;
                activo = false;
            }else if(this.advancedSearch.estatus_id !== 999){
                estatus_id = this.advancedSearch.estatus_id
                activo = true;
            }


            if (this.rol == "empleado") {
                empleado_id = this.$session.get("empleado").id;
            } else {
                empleado_id = this.advancedSearch.empleado_id;
            }

            if (this.rol == "admin") {
                cliente = this.datosLogin.cliente_id;
            } else if (this.rol == "admin-empresa") {
                cliente = this.datosLogin.cliente_id;
                empresa = this.datosLogin.empresa_id;
            } else if (this.rol == "admin-sucursal") {
                cliente = this.datosLogin.cliente_id;
                empresa = this.datosLogin.empresa_id;
                sucursal = this.datosLogin.sucursal_id;
            } else if (this.rol == "admin-depto") {
                cliente = this.datosLogin.cliente_id;
                empresa = this.datosLogin.empresa_id;
                sucursal = this.datosLogin.sucursal_id;
                departamento = this.datosLogin.departamento_id;
            }

            let filterParams = {
                tipo_id         : tipo_id,
                estatus_id      : estatus_id,
                min_fecha_inicio: fecha_inicio,
                max_fecha_final : fecha_final,
                empleado_id     : empleado_id,
                activo          : activo,

                cliente_id      : cliente,
                empresa_id      : empresa,
                sucursal_id     : sucursal,
                departamento_id : departamento,
                rol_name        : this.datosLogin.rol.name,
                usuario_id      : this.datosLogin.id,
            };

            let defaultParams = {
                paginate: true,
                include_padres: true,
                rol_name: this.datosLogin.rol.name,
                usuario_id: this.datosLogin.id,
            };

            if (filterParams != null) {
                Object.assign(defaultParams, filterParams);
            }

            this.filters = defaultParams;

            this.advancedSearch.tipo_id = null;
            this.advancedSearch.estatus_id = null;
            this.advancedSearch.fecha_inicio = null;
            this.advancedSearch.fecha_final = null;
            this.advancedSearch.empleado_id = null;

            this.cliente_value = null;
            this.empresa_value = null;
            this.sucursal_value = null;
            this.incidencia.departamento_id = null;
        },
        async loadModalData() {
            await this.resetValue();
            let cliente = null;
            let empresa = null;
            let sucursal = null;
            let depto = null;
            this.accion = 'search';
            if (this.rol == "root") {
                this.getClientes();
            }
            if (this.rol == "admin") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.cambiaCliente(this.datosLogin.cliente_id, this.accion);
                cliente = this.datosLogin.cliente_id;
            }

            if (this.rol == "admin-empresa") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
                this.cambiaEmpresa(this.datosLogin.empresa_id, this.accion);
                empresa = this.datosLogin.empresa_id;
            }

            if (this.rol == "admin-sucursal") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
                this.sucursal_value = this.datosLogin.sucursal_id;
                this.cambiaSucursal(this.datosLogin.sucursal_id, this.accion);
                sucursal = this.datosLogin.sucursal_id;
            }
            
            if(this.rol == "admin-depto"){
                this.getTiposIncidencias(this.datosLogin.empresa_id);
            }

            if(this.rol == "empleado"){
                this.getTiposIncidencias(this.datosLogin.empresa_id);
            }

            if (this.rol != "empleado" && this.rol != 'root'){
                this.getEmpleadosBusqueda()
            }
            
            this.getEstatusIncidencia();

            // let param = {
            //     activo          : true,
            //     paginate        : false,
            //     cliente_id      : cliente,
            //     empresa_id      : empresa,
            //     sucursal_id     : sucursal,
            //     departamento_id : depto,
            //     rol_name        : this.datosLogin.rol.name,
            //     usuario_id      : this.datosLogin.id,
            // };
            // if (this.rol != "empleado") {
            //     empleadosApi.getEmpleados(param).then((response) => {
            //         this.empleados = response.data.map((item) => ({nombreClave: `${item.clave} - ${item.nombre_completo}`, ...item}));
            //     })
            //     .catch((err) => {
            //         this.loading_guardar = false;
            //         console.error(err);
            //         Notify.ErrorToast("Ocurrió un error al cargar los empleados.");
            //     });
            // }

            this.finaliza_carga = true;
            //setTimeout(function(){ document.getElementById("btnBusquedaAvanzada").click(); }, 100);
        },
    
        async traerEstatus(){
            let parametros = {activo: true, paginate:false}

            await estatusIncidenciaApi.getEstatusIncidencias(parametros).then(resp =>{
                this.estatus_plus = resp.data
            }).catch(err =>{
                console.log('Ocurrio un error: ',err);
            })

            this.estatus_plus = [...this.estatus_plus,{id:999,nombre:"Cancelado"}]

        },

        async actualizarEstatus(item = null, estatus = null){
            this.incidencia.id              = item.id;
            this.incidencia.descripcion     = item.descripcion;
            this.incidencia.fecha_inicio    = item.fecha_inicio;
            this.incidencia.fecha_final     = item.fecha_final;
            this.incidencia.tipo_id         = item.tipo_id;
            this.incidencia.estatus_id      = estatus
            this.incidencia.cliente_id      = item.cliente_id;
            this.incidencia.empresa_id      = item.empresa_id;
            this.incidencia.sucursal_id     = item.sucursal_id;
            this.incidencia.departamento_id = item.departamento_id;
            this.incidencia.empleado_id     = item.empleado_id;
            this.incidencia.url_archivo     = item.url_archivo;
            this.url_archivo                = item.url_archivo;
            this.incidencia.url             = window.location.origin;
            
            //console.log(this.incidencia);
            this.frase = 'Actualizando'
            this.overlayDesgarga = true

           incidenciaApi.updateIncidencia(this.incidencia).then((response) => {
                this.listar();
                this.overlayDesgarga = false
                this.frase = 'Descargando archivo'
                this.respuesta_ok( "Se ha realizado la actualización correctamente.");
                this.$refs.tableIncidencias.getData();

                if (response.notificaciones && response.notificaciones.length > 0){
                    this.$emit("setNotifications", response.notificaciones);
                }
            })
            .catch((err) => {
                this.respuesta_error(err);
                this.overlayDesgarga = false
                this.frase = 'Descargando archivo'
            });

        },
        async abrirModal(accion, item = null) {
            await this.resetValue();
            this.accion = accion;
            this.finaliza_carga = false;
            if (accion == "add") {
                this.titulo_modal = "Registrar incidencia";
                this.imagen = "/static/modal/incidenciaCreate.svg";
                if (this.rol == "root") {
                    this.getClientes();
                }
                else if (this.rol == "admin") {
                    this.cliente_value = this.datosLogin.cliente_id;
                    this.cambiaCliente(this.datosLogin.cliente_id, this.accion);
                }
                else if (this.rol == "admin-empresa") {
                    this.cliente_value = this.datosLogin.cliente_id;
                    this.empresa_value = this.datosLogin.empresa_id;
                    this.cambiaEmpresa(this.datosLogin.empresa_id, this.accion);
                }
                else if (this.rol == "admin-sucursal") {
                    this.cliente_value = this.datosLogin.cliente_id;
                    this.empresa_value = this.datosLogin.empresa_id;
                    this.sucursal_value = this.datosLogin.sucursal_id;
                    this.cambiaSucursal(this.datosLogin.sucursal_id, this.accion);
                }
                else if(this.rol == 'admin-depto'){
                    this.cliente_value = this.datosLogin.cliente_id;
                    this.empresa_value = this.datosLogin.empresa_id;
                    this.sucursal_value = this.datosLogin.sucursal_id;
                    this.getTiposIncidencias(this.datosLogin.empresa_id);
                    this.getEmpleados();
                }
                else if (this.rol == "empleado") {
                    this.cliente_value = this.datosLogin.cliente_id;
                    this.empresa_value = this.datosLogin.empresa_id;
                    this.sucursal_value = this.datosLogin.sucursal_id;
                }
                this.finaliza_carga = true;
            } else if (accion == "update" || accion == 'subir-archivo') {
                if(accion == 'update'){
                    this.titulo_modal = "Actualizar incidencia";
                }
                else if(accion == 'subir-archivo'){
                    this.titulo_modal = 'Subir archivo'
                }
                this.imagen                     = "/static/modal/incidenciaUpdate.svg";
                if(accion !== 'subir-archivo'){
                    await this.getTiposIncidencias(item.empresa_id);
                }
                this.incidencia.id              = item.id;
                this.incidencia.descripcion     = item.descripcion;
                this.incidencia.fecha_inicio    = item.fecha_inicio;
                this.incidencia.fecha_final     = item.fecha_final;
                this.incidencia.tipo_id         = item.tipo_id;
                this.incidencia.estatus_id      = item.estatus_id;
                this.cliente_value              = item.cliente_id;
                this.empresa_value              = item.empresa_id;
                this.sucursal_value             = item.sucursal_id;
                this.departamento_value         = item.departamento_id;
                this.incidencia.empleado_id     = item.empleado_id;
                this.incidencia.url_archivo     = item.url_archivo;
                this.url_archivo                = item.url_archivo;
                if (this.rol == "root" && accion !== 'subir-archivo') {
                    this.getClientes();
                }

                
                if(accion !== 'subir-archivo'){
                    setTimeout(()=>this.$refs.FechaInicio.setDate(item.fecha_inicio),200);
                    setTimeout(()=>this.$refs.FechaFinal.setDate(item.fecha_final),200);
                }
            

                if (item.cliente != undefined) {
                    this.incidencia.cliente_id = item.cliente_id;
                }

                if (item.empresa != undefined) {
                    this.incidencia.empresa_id = item.empresa_id;
                }

                if (item.sucursal != undefined) {
                    this.incidencia.sucursal_id = item.sucursal_id;
                }

                if (item.departamento != undefined) {
                    this.incidencia.departamento_id = item.departamento_id;
                }

                if (item.empleado != undefined) {
                    this.incidencia.empleado_id = item.empleado_id;
                }

            }
            
            

            setTimeout(function() {
                document.getElementById("btnModal").click();
            }, 100);
        },
        abrirCancelar(id){
            this.cancelacion.id = id;
            this.modal_cancelar = true
        },
        guardar() {
            let self = this;
            var f_inicio = new Date(this.incidencia.fecha_inicio);
            var f_final = new Date(this.incidencia.fecha_final);

            self.valorIncidencia = null;
            this.tiposIncidencias.forEach(function(element) {
                if (element.id == self.incidencia.tipo_id)
                self.valorIncidencia = element.valor;
            });
            if (f_inicio > f_final) {
                Notify.Info("Rango de fechas incorrectas", "La fecha de inicio es mayor que la fecha final");
            } else if (
                (self.url_archivo == null || self.url_archivo == "" || self.url_archivo == undefined) 
                && self.valorIncidencia == "tipo_incidencia_incapacidad" 
                && (this.nombre_archivo == "" || this.nombre_archivo == null || this.nombre_archivo == undefined)
            ) {
                Notify.Info("Se requiere documento", "Para guardar la incidencia se requiere un documento");
            } else {
                this.$refs.form.validate().then(result => {
                    if (result) {
                        this.loading_guardar = true;
                        this.incidencia.cliente_id = this.cliente_value;
                        this.incidencia.empresa_id = this.empresa_value;
                        this.incidencia.sucursal_id = this.sucursal_value;
                        this.incidencia.departamento_id = this.departamento_value;

                        if(this.nombre_archivo != "" && this.nombre_archivo != null){
                            if(this.archivo.size > 5242880){
                                Notify.Info("El archivo es muy pesado", "El archivo debe ser menor a 5MB");
                                this.loading_guardar = false;
                                return;
                            }
                        }

                        if (this.accion === "add") {
                            if (this.rol == "empleado") {
                                this.incidencia.estatus_id = 1;
                                this.incidencia.empleado_id = this.$session.get("empleado").id;
                                this.incidencia.departamento_id = this.datosLogin.departamento_id;
                                /* this.incidencia.empleado_id = this.$session.get('usuario').id; */
                            }
                            
                            let formData = new FormData();

                            formData.append("empleado_id",this.incidencia.empleado_id);
                            formData.append("descripcion",this.incidencia.descripcion);
                            formData.append("tipo_id",this.incidencia.tipo_id);
                            formData.append("fecha_inicio",this.incidencia.fecha_inicio);
                            formData.append("fecha_final",this.incidencia.fecha_final);
                            formData.append("estatus_id",this.incidencia.estatus_id);
                            formData.append("url",window.location.origin)

                            if(self.archivo != 0){
                                formData.append("archivo", this.archivo);

                            }

                            incidenciaApi.addIncidencia(formData).then((response) => {
                                self.listar();
                                self.respuesta_ok("Se ha realizado la operación correctamente.");
                                self.$refs.tableIncidencias.getData();
                                //this.$emit("setNotifications", response.notificaciones);
                            })
                            .catch((err) => {
                                self.respuesta_error(err);
                            });

                                
                        } 
                        else if (self.accion === "update" || self.accion === 'subir-archivo') {
                            
                            let formData = new FormData();
                            
                            formData.append("id", this.incidencia.id);
                            formData.append("empleado_id",this.incidencia.empleado_id);
                            formData.append("descripcion",this.incidencia.descripcion);
                            formData.append("tipo_id",this.incidencia.tipo_id);
                            formData.append("fecha_inicio",this.incidencia.fecha_inicio);
                            formData.append("fecha_final",this.incidencia.fecha_final);
                            formData.append("estatus_id",this.incidencia.estatus_id);
                            formData.append("url",window.location.origin)
                                
                            if(self.archivo != 0){
                                formData.append("archivo", this.archivo);
                            }
                            
                            incidenciaApi.updateIncidencia(formData).then((response) => {
                                self.listar();
                                self.respuesta_ok("Se ha realizado la operacion correctamente.");
                                self.$refs.tableIncidencias.getData();

                                // if (response.notificaciones && response.notificaciones.length > 0){
                                //     self.$emit("setNotifications", response.notificaciones);
                                // }
                            })
                            .catch((err) => {
                                self.respuesta_error(err);
                            });      
                             
                        }
                    }
                });
            }
        },
        eliminar() {
            Notify.Alert2(
                "ADVERTENCIA",
                "¿Estás seguro que deseas cancelar la incidencia?",
                "Cancelar incidencia",
                "Cerrar",
                () => {
                    incidenciaApi.deleteIncidencia(this.cancelacion).then((response) => {
                    this.$refs.tableIncidencias.getData();
                    this.respuesta_ok("La incidencia ha sido cancelada satisfactoriamente");
                    })
                    .catch((err) => {
                            console.log(err);
                            Notify.ErrorToast(err.response.data.error);
                    });
                }
            );
            
            
        },
        async getTiposIncidencias(empresa = null) {
            let param           = {
                activo          : true,
                paginate        : false,
                empresa_id      : empresa,
            };
            await tiposIncidenciasApi.getTiposIncidencias(param).then((response) => {
                this.tiposIncidencias = response.data;
            })
            .catch((err) => {
                this.loading_guardar = false;
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los tipos de incidencias.");
            });
        },
        async getEstatusIncidencia(IdTipoIndidencia = null) {
            let tipoIncidencia = null;
            if(this.accion != 'search'){
                tipoIncidencia = await this.tiposIncidencias.find(incidencia => IdTipoIndidencia == incidencia.id)
            }

            let param = { activo: true, paginate: false };
            await estatusIncidenciaApi.getEstatusIncidencias(param).then((response) => {               
                let itemsEstatus = [];

                if(this.accion == "search"){
                    this.estatus = response.data;
                }
                else{
                    response.data.forEach(item => {
                        if(item.valor != "estatus_aprobado" && this.sistema == 'nominas' && tipoIncidencia && tipoIncidencia.valor == "tipo_incidencia_incapacidad"){
                            itemsEstatus.push(item)
                        }
                        else if(this.sistema == 'nominas' && tipoIncidencia && tipoIncidencia.valor != "tipo_incidencia_incapacidad"){
                            itemsEstatus.push(item)
                        }
                        else if(this.sistema == 'gdth'){
                            itemsEstatus.push(item)
                        }
                    })
                    this.estatus = itemsEstatus;
                }
                
            })
            .catch((err) => {
                this.loading_guardar = false;
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los estatus de las incidencias.");
            });
        },
        async getEmpleados() {
            let param = {
                rol_name: this.datosLogin.rol.name,
                usuario_id: this.datosLogin.id,
                activo: true,
                paginate: false,
            };
            await empleadosApi.getEmpleados(param).then((response) => {
                this.empleados = response.data.map((item) => ({nombreClave: `${item.clave} - ${item.nombre_completo}`, ...item}));
            })
            .catch((err) => {
                this.respuesta_error(err);
            });
        },
        async getClientes(clientes = null) {
            let param = { activo: true, paginate: false };
            await clientesApi.getClientes(param).then((response) => {
                this.clientes = response.data;
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los clientes.");
            });
        },
        async cambiaCliente(cliente, accion = null) {
            let param = { activo: true, paginate: false, cliente_id: cliente };
            await empresaApi.getEmpresas(param).then((response) => {
                this.empresas = response.data;
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        async cambiaEmpresa(empresa, accion = null) {
            let parametros = { activo: true, paginate: false, empresa_id: empresa };
            await sucursalApi.getSucursales(parametros).then((response) => {
                this.sucursales = response.data;
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las sucursales.");
            });
        },
        async cambiaSucursal(sucursal, accion = null) {
            let parametros = { activo: true, paginate: false, sucursal_id: sucursal };
            await departamentoApi.getDepartamentos(parametros).then((response) => {
                this.departamentos = response.data;
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los departamentos.");
            });
        },
        async cambiaDepartamento(departamento, accion = null) {
            let param = {
                rol_name: this.datosLogin.rol.name,
                usuario_id: this.datosLogin.id,
                activo: true,
                paginate: false,
                departamento_id: departamento,
            };
            await empleadosApi.getEmpleados(param).then((response) => {
                this.finaliza_carga = true;
                /* let formateado = response.data;
                formateado.forEach((element) => {
                    let nombre = element["nombre"];
                    let apellido_paterno = element["apellido_paterno"];
                    element["nombre_completo"] = nombre + " " + apellido_paterno;
                }); */
                this.empleados = response.data.map((item) => ({nombreClave: `${item.clave} - ${item.nombre_completo}`, ...item}));
            })
            .catch((err) => {
                this.finaliza_carga = true;
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los empleados.");
            });
        },
        async getEmpleadosBusqueda() {
            if(this.accion != 'search'){
                return
            }

            this.advancedSearch.empleado_id = null

            let param = {
                rol_name: this.datosLogin.rol.name,
                usuario_id: this.datosLogin.id,
                activo: true,
                paginate: false,
                cliente_id: this.cliente_value,
                empresa_id: this.empresa_value,
                sucursal_id: this.sucursal_value,
                departamento_id: this.advancedSearch.departamento_id,

            };
            await empleadosApi.getEmpleados(param).then((response) => {
                this.empleados = response.data.map((item)=>({
                    nombreClave: `${item.clave} - ${item.nombre_completo}`,
                    ...item
                }));
            })
            .catch((err) => {
                this.finaliza_carga = true;
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los empleados.");
            });
        },
        async cerrarModal() {
            this.dialog = false;
            this.dialogReportes = false;
            this.modal_cancelar = false;
            await this.resetValue();

            

        },
        async resetValue() {
            this.incidencia.id              = null;
            this.incidencia.descripcion     = ""; 
            this.incidencia.tipo_id         = null;
            this.incidencia.estatus_id      = "";
            this.incidencia.fecha_inicio    = "";
            this.incidencia.fecha_final     = "";
            this.incidencia.empleado_id     = "";
            this.incidencia.cliente_id      = null;
            this.incidencia.empresa_id      = null;
            this.incidencia.sucursal_id     = null;
            this.incidencia.departamento_id = null;
            this.incidencia.url_archivo     = "";
            this.clientes                   = [];
            this.empresas                   = [];
            this.sucursales                 = [];
            this.departamentos              = [];
            this.empleados                  = [];
            this.tiposIncidencias           = [];
            this.estatus                    = [];
            this.cliente_value              = null;
            this.empresa_value              = null;
            this.sucursal_value             = null;
            this.departamento_value         = null;
            this.loading_guardar            = false;
            this.conteo_parametros          = 0;
            this.archivo                    = 0;
            this.nombre_archivo             = "";
            this.menu_final                 = false;
            this.menu_inicio                = false;
            this.fecha_final                = null;
            this.fecha_inicio               = null;
            this.url_archivo                = null;
            this.cancelacion = {
                id: null,
                motivo: ''
            }            
            $("#archivo").val("");

            this.advancedSearch = {
                rol_name    : null,
                usuario_id  : null,
                tipo_id     : null,
                estatus_id  : null,
                fecha_inicio: null,
                fecha_final : null,
                empleado_id : null,
                cliente_id  : null,
                empresa_id  : null,
                sucursal_id : null,
                departamento_id: null,
            };

            if(this.$refs.FechaInicio != undefined || this.$refs.FechaInicio != null){
                this.$refs.FechaInicio.resetDate();
            }
            if(this.$refs.FechaFinal != undefined || this.$refs.FechaFinal != null){
                this.$refs.FechaFinal.resetDate();
            }

            if(this.$refs.SearchFechaInicio != undefined || this.$refs.SearchFechaInicio != null){
                this.$refs.SearchFechaInicio.resetDate();
            }
            if(this.$refs.SearchFechaFinal != undefined || this.$refs.SearchFechaFinal != null){
                this.$refs.SearchFechaFinal.resetDate();
            }

            this.$nextTick(() => {
                if(this.$refs.form != undefined || this.$refs.form != null){
                    this.$refs.form.reset();
                }
                if(this.$refs.formCancelar != undefined || this.$refs.formCancelar != null){
                    this.$refs.formCancelar.reset();
                }
                if(this.$refs.formReporte != undefined || this.$refs.formReporte != null){
                    this.$refs.formReporte.reset();
                }
                 
            });
        },
        respuesta_error(err) {
            this.loading_guardar = false;
            if(typeof err.response.data.error === 'string'){
                Notify.ErrorToast(err.response.data.error);
            }else{
                let error = Object.values(err.response.data.error);
                let leyenda = ``;

                for (var i = 0; i < error.length; i++) {
                    leyenda+= `* ` + error[i] + `\n`;
                }

                Notify.ErrorToast(leyenda);
            }
        },
        async respuesta_ok(msj = "") {
            await this.cerrarModal();
            await this.listar();
            this.dialog = false;
            Notify.Success("Operación exitosa", msj);
        },
        async valida_empleado() {
            let self = this;
            let empleado = this.$session.get("empleado");
            if (empleado != undefined) {
                await this.listar();
            } else {
                setTimeout(async () => {
                    await this.valida_empleado();
                }, 300);
            }
        },
        pickFile() {
            this.$refs.image.click();
        },
        onFilePicked(e) {
            const files = e.target.files;
            if (files[0] !== undefined) {
                this.nombre_archivo = files[0].name;
                if (this.nombre_archivo.lastIndexOf(".") <= 0) {
                    return;
                }
                const fr = new FileReader();
                fr.readAsDataURL(files[0]);
                fr.addEventListener("load", () => {
                    this.archivo = files[0];
                });
            } else {
                this.nombre_archivo = "";
                this.archivo = null;
            }
        },
        async descargar(item = null) {
            const FileDownload = require("js-file-download");
            let self = this;
            const axios = require("axios");
            let url = "incidencias/download";
            var nombre = item.url_archivo.split("/");
            let parametros = { url_archivo: item.url_archivo };
            this.overlayDesgarga = true;
            try {
                axios({
                    method: "post",
                    url: url,
                    responseType: "blob",
                    data: parametros,
                }).then(function(response) {
                    self.overlayDesgarga = false;
                    FileDownload(response.data, nombre[nombre.length-1]);
                });
            } catch (error) {
                self.overlayDesgarga = false;
                console.log(error);
            }
        },
        async descargarFormato(item = null) {
            //console.log(item)
            this.overlayDesgarga = true
            const FileDownload = require("js-file-download");
            const axios = require("axios");
            let url = `incidencias/formato_vacaciones/${item.id}`;
            var nombre = `formato_vacaciones_${item.nombre_completo}.pdf`;
            try {
                axios({
                    method: "get",
                    url: url,
                    responseType: "blob",
                }).then((response) => {
                    FileDownload(response.data, nombre);
                    this.overlayDesgarga = false
                }).catch(async(error)=>{
                    this.overlayDesgarga = false
                    let errorString = error.response.data;
                    if (
                        error.request.responseType === 'blob' &&
                        error.response.data instanceof Blob &&
                        error.response.data.type &&
                        error.response.data.type.toLowerCase().indexOf('json') != -1
                    ){
                        errorString = JSON.parse(await error.response.data.text());

                        if(typeof errorString.error === 'string'){
                            Notify.ErrorToast(errorString.error);
                        }else{
                            let error = Object.values(errorString.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }
                            Notify.ErrorToast(leyenda);
                        }
                    }; 
                });
            } catch (error) {
                this.overlayDesgarga = false
                console.log(error);
            }
        },
        async exportar(tipo_doc = null) {
            let sefl = this;
            this.overlayDesgarga = true;
            let url = "reportes/incidencias";
            const FileDownload = require("js-file-download");
            var today = new Date();
            let nombre;
            if(tipo_doc == 'xlsx'){
                nombre = "incidencias_" +
                today.getDate() +
                "_" +
                (today.getMonth() + 1) +
                "_" +
                today.getFullYear() +
                ".xlsx";
            }
            else{
                nombre = "incidencias_" +
                today.getDate() +
                "_" +
                (today.getMonth() + 1) +
                "_" +
                today.getFullYear() +
                ".pdf";
            }
            this.filters.tipo = tipo_doc;
            const object1 = this.filters;
            try {
                await Vue.axios({
                    method: "GET",
                    responseType: "blob",
                    url: url,
                    params: object1,
                }).then((response, status, xhr) => {
                    FileDownload(response.data, nombre);
                    this.overlayDesgarga = false;
                }).catch(async(error)=>{
                    this.overlayDesgarga = false;
                    let errorString = error.response.data;
                            if (
                                error.request.responseType === 'blob' &&
                                error.response.data instanceof Blob &&
                                error.response.data.type &&
                                error.response.data.type.toLowerCase().indexOf('json') != -1
                            ){
                                errorString = JSON.parse(await error.response.data.text());

                                if(typeof errorString.error === 'string'){
                                    Notify.ErrorToast(errorString.error);
                                }else{
                                    let error = Object.values(errorString.error);
                                    let leyenda = ``;

                                    for (var i = 0; i < error.length; i++) {
                                        leyenda+= `* ` + error[i] + `\n`;
                                    }
                                    Notify.ErrorToast(leyenda);
                                }
                            }; 
                });
            } catch (e) {
                this.overlayDesgarga = false;
                var message = null;
            }
        },
        getColorTextoStatus(statusIncidencia) {
            if (statusIncidencia == "estatus_aprobado") return "div-aprobado";
            if (statusIncidencia == "estatus_rechazado") return "div-rechazado";
            if (statusIncidencia == "estatus_pendiente") return "div-pendiente";
            if (statusIncidencia == "estatus_revision") return "div-revision";
        },
        init() {
            const elementScroll = document.querySelector("#scroll");
            if (elementScroll) {
                const ps = new PerfectScrollbar(elementScroll, {
                wheelSpeed: 2,
                wheelPropagation: true,
                minScrollbarLength: 20,
                suppressScrollY: true,
                });
            }
            $(".ps__thumb-x").css("position", "fixed");
            /* $("tr th:nth-child(6)").css("width", "17%");
            $("tr th:nth-child(2)").css("width", "15%"); */
        },
        dateFormat(fecha) {
            let fecha2 = fecha.split("-");
            return fecha2[2] + " / " + fecha2[1]+ " / " + fecha2[0];
        },
        async abrirModalReportes(){
            await this.resetValue()
            if (this.rol == "root") {
                this.getClientes();
            }
            if (this.rol == "admin") {
                this.cliente_value = this.datosLogin.cliente_id;
            }
            setTimeout(()=>{
                document.getElementById("btnModalReportes").click();
            }, 100);
        },
        async exportarReporte(tipo_doc = null) {
            let self = this;
            let url = "reportes/incidencias";
            const FileDownload = require("js-file-download");

            this.$refs.formReporte.validate().then(result => {
                if (result) {
                    this.isSaving = true;
                    var today = new Date();
                    let nombre;
                    if(tipo_doc == 'xlsx'){
                        nombre = "incidencias_" +
                        today.getDate() +
                        "_" +
                        (today.getMonth() + 1) +
                        "_" +
                        today.getFullYear() +
                        ".xlsx";
                    }
                    else{
                        nombre = "incidencias_" +
                        today.getDate() +
                        "_" +
                        (today.getMonth() + 1) +
                        "_" +
                        today.getFullYear() +
                        ".pdf";
                    }
                    let filtros = {
                        items_to_show: 200,
                        tipo:tipo_doc,
                        activo: true,
                        include_padres: true,
                        rol_name: "admin-empresa",
                        usuario_id: this.datosLogin.id,
                        cliente_id: this.cliente_value,
                        empresa_id: this.empresa_value,
                        min_fecha_inicio: this.advancedSearch.fecha_inicio,
                        max_fecha_final : this.advancedSearch.fecha_final,            
                    }
                    const object1 = filtros;
                    try {
                        Vue.axios({
                            method: "GET",
                            responseType: "blob",
                            url: url,
                            params: object1,
                        }).then((response, status, xhr) => {
                            self.isSaving = false;
                            FileDownload(response.data, nombre);
                            self.cerrarModal();
                        })
                        .catch(async (error)=>{
                            self.isSaving = false;
                            let errorString = error.response.data;
                            if (
                                error.request.responseType === 'blob' &&
                                error.response.data instanceof Blob &&
                                error.response.data.type &&
                                error.response.data.type.toLowerCase().indexOf('json') != -1
                            ){
                                errorString = JSON.parse(await error.response.data.text());

                                if(typeof errorString.error === 'string'){
                                    Notify.ErrorToast(errorString.error);
                                }else{
                                    let error = Object.values(errorString.error);
                                    let leyenda = ``;

                                    for (var i = 0; i < error.length; i++) {
                                        leyenda+= `* ` + error[i] + `\n`;
                                    }
                                    Notify.ErrorToast(leyenda);
                                }
                            }; 
                            
                        });
                    } catch (e) {
                        self.isSaving = false;
                        Notify.ErrorToast("Se produjo un error al realizar la petición.");
                    }
                }
            });
        },
    },
    mounted() {
        //this.init();
    },
    async created() {
        let self = this;
        let session = this.$session.get("usuario").rol.name;
        this.sistema = this.$session.get('sistema');
        this.datosLogin = this.$session.get("usuario");
        this.rol = this.datosLogin.rol.name;
        this.traerEstatus()
        if (session != "empleado") {
            await this.listar();
        } else {
            //await this.valida_empleado();
            let empleado = this.$session.get("empleado");
            if (empleado != undefined) {
                await this.listar();
            } else {
                setTimeout(async () => {
                    await this.valida_empleado();
                }, 300);
            }
        }
    },
};
</script>

<style scoped>
    
    .div-aprobado{
        color: #15D511;
    }
    
    .div-rechazado{
        color: #EE1616;
    }
    
    .div-pendiente{
        color: #FF9B05;
    }
    
    .div-revision{
        color: #F8690E;
    }


    .div-cancelado{
        font-weight: 500;
        color:#000;
    }

    .vChip {
        width: 120px;
        justify-content: center;
        font-size: 12px;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
    }
    .vChip .v-chip .v-chip__content {
        font-family: Montserrat !important;
        font-size: 12px !important;
        font-weight: 500 !important;
        letter-spacing: -0.34px !important;
        line-height: 17px !important;
        width: 90px !important;
        color: #2c2b2b !important;
    }

    .v-chip .v-chip__content {
        font-family: Montserrat !important;
        font-style: normal;
        font-weight: 500 !important;
        font-size: 12px !important;
        line-height: 15px !important;
        text-align: center !important;
        color: #2c2b2b !important;
    }
    .tipoLetra {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 14px !important;
        line-height: 20px;
        text-align: center;
    }
    .v-chip-hover .v-chip .v-chip__content:hover {
        background-color: blue !important;
    }
    .tituloRadio{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 14px;
        letter-spacing: 0.2px;
        color: #A0A4A8;
        padding-bottom: 10px;
    }

    /*Clases de menu de opciones*/
    .menuClassAcciones{
        /* box-shadow: none; */
        border-radius: 10px!important;
        margin-top:15px;
    }
    .btnAcciones {
        width: 135px !important;
        height: 42px !important;
        border-radius: 30px;
        text-transform: capitalize;
        background:#58C5D8 !important;
        color:#FFFFFF !important;
        font-family: "Montserrat" !important;
        font-style: normal !important;
        font-weight: 600 !important;
        font-size: 14px !important;
        line-height: 17px !important;
    }
    .btnAcciones:hover {
        width: 135px !important;
        height: 42px !important;
        border-radius: 30px;
        text-transform: capitalize;
        background:#58C5D8 !important;
        color:#FFFFFF !important;
        font-family: "Montserrat" !important;
        font-style: normal !important;
        font-weight: 600 !important;
        font-size: 14px !important;
        line-height: 17px !important;
        box-shadow: 0px 5px 8px rgba(26, 30, 66, 0.2);
        -webkit-transform: translatey(-1px);
        transform: translatey(-1px);
    }
    .btnAccionesContenedor {
        width: 300px;
        height: auto;
        padding-top: 10px;
        padding-bottom: 10px;
        background-color: #FFF;
    }
    div.btnAccionesTitulo {
        padding-left: 30px;
        padding-right: 30px;
    }
    div.btnAccionesTitulo span {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        text-align: left;
        color: #1E2245;
    }
    div.btnAccionesItem {
        width: 100%;
        cursor: pointer;
        outline: 0;
        padding-left: 30px;
        padding-right: 30px;
    }
    div.btnAccionesItem span {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        text-align: left;
        color: #828282;
    }
    div.btnAccionesItem:hover {
        background: #F6F6F8;
    }

    .eliminado{
        background-color: #FDAEAE;
    }

    .btnCancelar {
        height: 42px !important;
        border-radius: 30px;
        text-transform: none;
        background:#D41010 !important;
        color:#FFFFFF !important;
        font-family: "Montserrat" !important;
        font-style: normal !important;
        font-weight: 600 !important;
        font-size: 14px !important;
        line-height: 17px !important;
    }

    .header-cancelar {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-items: center;
    }
    .header-cancelar-h2 {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 17px;
        color: #4F4F4F;
    }
    .header-cancelar-h3 {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        text-align: center;
        color: #828282;
    }

    .alert-div{
        border-left: 9px solid #D93025;
        padding-left: 10px;

        background: rgba(250, 230, 229, 0.6);
        border-radius: 5px
    }

    .alert-sub {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 22px;
        color: #C5352B;
    }

    .menuClassAccionesVer{
        border-radius: 10px!important;
    }
    .menu-width{
        max-width: 500px;
        min-width: 450px;
        border-radius: 20px !important;
    }

    .v-btn-cerrar:hover:before {
      background-color: transparent;
      
    }
    .v-btn-cerrar:before {
        display: none;
    }
    .informacionGeneralTitulo{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #1E2245;
    }
    .informacionGeneralSubtitle{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        color: #828282;
    }
    .informacionGeneralText{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #4F4F4F;
    }
    .informacionCancelacion{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #1E2245;
    }
    .canceladoText{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color:#D41010 !important;
    }


</style>
